import { render, staticRenderFns } from "./InputContent.vue?vue&type=template&id=65a2d24a&scoped=true&"
import script from "./InputContent.vue?vue&type=script&lang=js&"
export * from "./InputContent.vue?vue&type=script&lang=js&"
import style0 from "./InputContent.vue?vue&type=style&index=0&id=65a2d24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a2d24a",
  null
  
)

export default component.exports